<template lang="html">
  <default-layout>
    <div class="grid grid-cols-4">
      <div
        v-if="(googleClassroomIntegration || edLinkIntegrations) && activityID"
        class="col-start-2 col-end-4"
      >
        <div class="mt-10 text-base font-semibold">
          Parlay needs you to connect to your account to the following system(s)
          before joining this course. Click the “Connect” button to do this, and
          then press the “Go To RoundTable” button once you are connected.
        </div>
        <div v-if="googleClassroomIntegration">
          <integration-student-card
            :title="google_classroom_title"
            :icon="google_classroom_icon"
            :code="google_classroom_code"
          />
        </div>
        <div v-if="edLinkIntegrations">
          <div v-for="(integration, key) in rt_integrations" v-bind:key="key">
            <integration-student-card
              :integration="integration"
              :title="integration.provider_name"
              :code="integration.id"
            />
          </div>
        </div>
        <div class="mt-10 flex justify-center">
          <button
            class="px-8 py-2 bg-primary text-white rounded font-semibold disabled:opacity-50"
            @click="goToRoundtable"
            :disabled="!disabledButton"
          >
            Go To Roundtable
          </button>
        </div>
      </div>
      <div
        v-if="!googleClassroomIntegration && !edLinkIntegrations"
        class="col-start-2 col-end-4 flex flex-col items-center justify-center"
      >
        <div class="mt-10 text-base font-semibold">
          No integrations to connect
        </div>
        <div v-if="!getProfile.google_integration.connected">
          <div class="mt-5">Connect your Google Account</div>
          <div class="mt-2.5 flex justify-center">
            <button
              class="px-8 py-2 bg-primary text-white rounded font-semibold"
              @click="connectGoogleClassroom"
            >
              Connect
            </button>
          </div>
        </div>
      </div>
    </div>
  </default-layout>
</template>
<script>
  import { mapGetters } from 'vuex';
  import courseSocketMixin from 'mixins/sockets/courseSocketEvents';
  import integrationStudentCard from 'features/courses/components/integrationStudentCard.vue';
  import defaultLayout from 'layouts/default/default.vue';
  import googleClassroom from 'utils/googleClassroom';
  import urlConfigs from 'services/apiConfigs';

  export default {
    components: {
      defaultLayout,
      integrationStudentCard,
    },
    data() {
      return {
        google_classroom_title: 'Google Classroom',
        google_classroom_icon: '/static/google_class_round.png',
        google_classroom_code: 'google-classroom',
        roundTable_id: null,
        submission: {},
      };
    },
    mixins: [courseSocketMixin],
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getRoleInCourse',
        'getProfile',
        'getMySubscription',
        'getCurrentRT',
        'getCurrentDiscussion',
      ]),
      googleClassroomIntegration() {
        return (
          this.submission &&
          this.submission.google_classroom_integration &&
          this.submission.google_classroom_integration.connected
        );
      },
      activityID() {
        return this.$route.query.roundtableID || this.$route.query.discussionID;
      },
      activityType() {
        return this.$route.query.roundtableID ? 'online' : 'live';
      },
      disabledButton() {
        if (
          this.googleClassroomIntegration &&
          this.getProfile.google_integration
        ) {
          return this.getProfile.google_integration.connected;
        } else if (
          this.getProfile.edlink_integrations &&
          this.getProfile.edlink_integrations.length
        ) {
          //only one integration per roundTable
          const rt_integration = this.rt_integrations[0];
          const userIntegration = this.getProfile.edlink_integrations.find(
            (x) => x.id === rt_integration.id && x.connected === true
          );
          if (userIntegration) {
            return true;
          }
        }
        return false;
      },
      edLinkIntegrations() {
        return (
          this.submission &&
          this.submission.edlink_integrations &&
          this.submission.edlink_integrations.length
        );
      },
      rt_integrations() {
        return this.getCourseDetail.edlink_integrations.filter((x) =>
          this.submission.edlink_integrations.map((i) => i.id).includes(x.id)
        );
      },
    },
    methods: {
      getMySubmission() {
        return this.getCurrentRT.submissions.find(
          (x) => x.user.id === this.getProfile.id
        );
      },
      getMyParticipation() {
        return this.getCurrentDiscussion.participations.find(
          (x) => x.user.id === this.getProfile.id
        );
      },
      mySubmission() {
        const sub = this.$route.query.roundtableID
          ? this.getMySubmission()
          : this.getMyParticipation();
        this.submission = sub;
      },
      goToRoundtable() {
        let route = {};
        if (this.activityType === 'online') {
          if (
            this.roundTable_id === undefined ||
            this.roundTable_id === null ||
            this.roundTable_id === 'undefined'
          ) {
            route = {
              name: 'course.index',
              params: { courseID: this.$route.params.courseID },
            };
          } else {
            route = {
              name: 'roundtable.prompt',
              params: {
                courseID: this.$route.params.courseID,
                roundtableID: this.roundTable_id,
              },
            };
          }
        } else {
          if (
            this.activityID === undefined ||
            this.activityID === null ||
            this.activityID === 'undefined'
          ) {
            route = {
              name: 'course.index',
              params: { courseID: this.$route.params.courseID },
            };
          } else {
            route = {
              name: 'live-discussion.prompt',
              params: {
                courseID: this.$route.params.courseID,
                liveDiscussionID: this.activityID,
              },
            };
          }
        }

        this.$router.push(route);
      },
      async connectGoogleClassroom() {
        if (!this.getProfile.google_integration.connected) {
          const { code, email } = await googleClassroom.getCode('student');
          const payload = {
            code,
            redirect_uri: urlConfigs.uiURL,
            email,
          };
          const course_id = this.getCourseDetail.id;
          this.$store
            .dispatch('connectStudentGoogleClassroomIntegration', {
              course_id,
              payload,
            })
            .then(() => {
              setTimeout(() => {
                this.goToRoundtable();
              }, 500);
            });
        }
      },
    },
    async mounted() {
      this.setupCourseSocket(this.$route.params.courseID);
      if (
        !this.getCourseDetail.id ||
        this.getCourseDetail.id !== this.$route.params.courseID
      ) {
        await this.$store.dispatch(
          'fetchCourseDetails',
          this.$route.params.courseID
        );
      }
      if (!this.getCurrentRT.id && this.$route.query.roundtableID) {
        await this.$store.dispatch(
          'fetchRoundtable',
          this.$route.query.roundtableID
        );
      }
      if (this.$route.query.discussionID && !this.getCurrentDiscussion.id) {
        await this.$store.dispatch(
          'fetchLiveDiscussion',
          this.$route.query.discussionID
        );
      }
      this.mySubmission();
      if (sessionStorage.getItem('activity_id')) {
        this.roundTable_id = sessionStorage.getItem('activity_id');
        sessionStorage.removeItem('activity_id');
      } else if (this.$route.query.roundtableID) {
        this.roundTable_id = this.$route.query.roundtableID;
      }
    },
    beforeDestroy() {
      this.leaveCourseSocket(this.$route.params.courseID);
    },
  };
</script>
<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// studentSettings.vue?2008c210